// extracted by mini-css-extract-plugin
export default {"storage_wrapper":"ModalStorage_storage_wrapper__GafBZ","back":"ModalStorage_back__7Pm1G"};